import React from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import { Box, Typography, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import "../../../../assets/styles/products_menu_build_styles.css";

function ProductsMenuBuild({ items, setHasChanges, setItemsWithCorrectOrderValue, onDeleteProduct }) {
  const [currentItems, setCurrentItems] = React.useState([]);

  // Efecto para actualizar currentItems cada vez que items cambia
  React.useEffect(() => {
    const sortedItems = [...items].sort((a, b) => a.order - b.order);
    setCurrentItems(sortedItems);
  }, [items]);

  const onSortEnd = (oldIndex, newIndex) => {
    const newItems = arrayMove(currentItems, oldIndex, newIndex);

    const updatedItems = newItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));

    setCurrentItems(updatedItems);
    setItemsWithCorrectOrderValue(updatedItems);
    setHasChanges(true);
  };

  const handleDelete = (e, item) => {
    e.stopPropagation(); // Evita que el clic active el arrastre o la selección
    const identifier = item.product_id || item.id; // Usa product_id si existe, sino id
    onDeleteProduct(identifier);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <SortableList
        onSortEnd={onSortEnd}
        className="list"
        draggedItemClassName="dragged"
      >
        {currentItems.map((item, index) => (
          <SortableItem key={index}>
            <Box
              className="item"
              style={{
                backgroundImage: `url(${item.image_url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                width: "250px",
                position: "relative", // Para posicionar el botón eliminar
              }}
            >
              <IconButton
                size="small"
                onClick={(e) => handleDelete(e, item)}
                sx={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "rgba(255,0,0,0.7)",
                  },
                  zIndex: 10,
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
              <Box
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    transition: "background 0.3s ease",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    position: "relative",
                    zIndex: 1,
                    padding: "5px",
                    borderRadius: "4px",
                  }}
                >
                  {item.name} <br />
                  $ {Number(item.price).toLocaleString()}
                </Typography>
              </Box>
            </Box>
          </SortableItem>
        ))}
      </SortableList>
    </Box>
  );
}

export default ProductsMenuBuild;